/**
 * Datas na tela do supervisor.
 *
 * A API manda ISO 8601 em UTC; quem lê está no armazém. A conversão para o
 * fuso do navegador é feita aqui, em um lugar só — data formatada à mão em
 * cada tela é como um turno vira o outro sem ninguém perceber.
 *
 * É o ÚNICO formatador do painel. Havia um segundo em `pages/movimentacoes`
 * que escrevia "16/08/2026 11:32" enquanto este escrevia "16/08/2026, 11:32":
 * o mesmo instante saía diferente conforme a tela.
 */

const DATA = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

/** Ano com quatro dígitos: a trilha é registro, e "26" não diz de qual século. */
const HORA = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' });

function instante(iso: string | null | undefined): Date | null {
  if (iso === null || iso === undefined || iso.trim() === '') {
    return null;
  }

  const data = new Date(iso);
  return Number.isNaN(data.getTime()) ? null : data;
}

/** `vazio` é texto, não traço: "—" numa coluna de acesso não diz se nunca houve um. */
export function formatarDataHora(iso: string | null | undefined, vazio = '—'): string {
  const data = instante(iso);
  return data === null ? vazio : `${DATA.format(data)} ${HORA.format(data)}`;
}

export function formatarHora(iso: string | null | undefined, vazio = '—'): string {
  const data = instante(iso);
  return data === null ? vazio : HORA.format(data);
}

/**
 * Data de calendário (validade de lote): `AAAA-MM-DD`, ou o dia de um ISO.
 *
 * Não passa por `Date`: validade é um DIA, não um instante, e convertê-la
 * para o fuso do navegador escreveria a véspera em todo o Brasil.
 */
export function formatarDataCivil(texto: string | null | undefined, vazio = '—'): string {
  const partes = /^(\d{4})-(\d{2})-(\d{2})/u.exec(texto ?? '');
  return partes === null ? vazio : `${partes[3] ?? ''}/${partes[2] ?? ''}/${partes[1] ?? ''}`;
}

/** Dia por extenso, com dia da semana — situa a pessoa na barra superior. */
const DATA_LONGA = new Intl.DateTimeFormat('pt-BR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

export function formatarDataLonga(data: Date): string {
  const texto = DATA_LONGA.format(data);
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}
